import React from "react";

// libraries
import html2pdf from "html2pdf.js";

// utils
import { exportStationToCsv } from "./../../../../../utils/csvHelper";
import { sanitizeFileName } from "./../../../../../utils/sanitizeFileName";

export const generateReportFile = async ({
  currentStation,
  reportFormat,
  statRef,
}) => {
  const stationName = sanitizeFileName(currentStation?.name || "station");

  if (reportFormat === "csv") {
    const csvContent = exportStationToCsv(currentStation);
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    return new File([blob], `${stationName}-report.csv`, {
      type: "text/csv",
    });
  }

  if (reportFormat === "pdf") {
    if (!statRef?.current) {
      throw new Error("Statistics element not found");
    }

    const sourceElement = statRef.current;
    const renderHost = document.createElement("div");
    const clonedElement = sourceElement.cloneNode(true);

    renderHost.style.position = "fixed";
    renderHost.style.inset = "0";
    renderHost.style.opacity = "0";
    renderHost.style.pointerEvents = "none";
    renderHost.style.overflow = "visible";
    renderHost.style.zIndex = "-1";

    clonedElement.style.width = "max-content";
    clonedElement.style.maxWidth = "none";

    const clonedTableWrapper = clonedElement.querySelector(
      ".p-datatable-wrapper",
    );
    const clonedTable = clonedElement.querySelector(".p-datatable-table");

    if (clonedTableWrapper) {
      clonedTableWrapper.style.overflow = "visible";
      clonedTableWrapper.style.maxHeight = "none";
      clonedTableWrapper.style.width = "max-content";
    }

    if (clonedTable) {
      clonedTable.style.width = "max-content";
    }

    renderHost.appendChild(clonedElement);
    document.body.appendChild(renderHost);

    await new Promise((resolve) => requestAnimationFrame(resolve));

    const contentWidth = Math.max(
      clonedElement.scrollWidth,
      clonedTable?.scrollWidth || 0,
      sourceElement.scrollWidth,
    );

    const pdfOptions = {
      margin: [10, 10, 10, 10],
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: -window.scrollY,
        width: contentWidth,
        windowWidth: contentWidth,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: contentWidth > 900 ? "landscape" : "portrait",
      },
    };

    let pdfBlob;
    try {
      pdfBlob = await html2pdf()
        .set(pdfOptions)
        .from(clonedElement)
        .outputPdf("blob");
    } finally {
      if (document.body.contains(renderHost)) {
        document.body.removeChild(renderHost);
      }
    }

    return new File([pdfBlob], `${stationName}-report.pdf`, {
      type: "application/pdf",
    });
  }

  throw new Error("Unsupported report format");
};
